module.exports = __webpack_public_path__ + "img/wangluo.4ac87fb0.jpg";